<template>
  <div class="col-12 col-lg-6 weather-item-col">
    <div class="weather-item">
      <div class="weather-item__title"><span>Температура воздуха °C</span><img src="@/assets/images/icon_meteo_01.svg" width="12" alt=""></div>
      <div class="weather-temp-circle-data text-right">
        <div class="weather-temp-circle" :style="tempColor">
          <span><i>{{temperature}}</i></span>
        </div>
        <div class="weather-temp-data text-center">
          <div class="weather-temp-data__title">
            <p>Точка росы</p>
            <span>{{dewpoint}} °C</span>
          </div>
          <div class="weather-temp-data__title">
            <p>Влажность </p>
            <span>{{humidity}} %</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Meteo from '@/helpers/Meteo'
import object from 'lodash/object'

export default {
  name: 'Temperature',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      meteo: null
    }
  },
  created () {
    this.meteo = new Meteo(this.station)
  },
  methods: {
    colorsFunct (tempdegs) {
      let colorTop, colorBottom
      const colorsArray = [
        [-40, '#aa00ff'],
        [-37.5, '#8500ff'],
        [-30, '#007dff'],
        [-22.5, '#00c1ff'],
        [-15, '#00d6ff'],
        [-7.5, '#00e2ff'],
        [0, '#00ffb4'],
        [7.5, '#00ff20'],
        [15, '#ffe700'],
        [22.5, '#ffc200'],
        [30, '#ff9800'],
        [37.5, '#ff7500'],
        [40, '#ff3800']
      ]

      for (let i = 0; i < colorsArray.length; i++) {
        colorsArray[i][0] >= 0 ? colorsArray[i][colorsArray[i].length] = colorsArray[i - 1][1] : colorsArray[i][colorsArray[i].length] = colorsArray[i + 1][1]
      }
      if (tempdegs < colorsArray[0][0]) {
        colorTop = colorsArray[0][1]
        colorBottom = colorsArray[0][1]
      } else if (tempdegs > colorsArray[colorsArray.length - 1][0]) {
        colorTop = colorsArray[colorsArray.length - 1][1]
        colorBottom = colorsArray[colorsArray.length - 1][1]
      } else {
        for (let j = 0; j < colorsArray.length; j++) {
          if (tempdegs >= 0) {
            if (colorsArray[j][0] >= tempdegs) {
              colorTop = colorsArray[j][1]
              colorBottom = colorsArray[j][2]
              j = colorsArray.length
            }
          } else {
            if (colorsArray[j][0] > tempdegs) {
              colorTop = colorsArray[j - 1][1]
              colorBottom = colorsArray[j - 1][2]
              j = colorsArray.length
            }
          }
        }
      }

      return {
        background: 'linear-gradient(to bottom, ' + colorTop + ' 20%, ' + colorBottom + ' 100%)'
      }
    }
  },
  computed: {
    tempColor () {
      return this.colorsFunct(this.temperature)
    },
    temperature () {
      if (this.$store.getters['station/lastData'] === null) {
        return 0
      }
      const path = [this.meteo.getId(), this.meteo.getAirTemperature()]

      return object.get(this.$store.getters['station/lastData'], path)
    },
    humidity () {
      if (this.$store.getters['station/lastData'] === null) {
        return 0
      }
      const path = [this.meteo.getId(), this.meteo.getHumidity()]

      return object.get(this.$store.getters['station/lastData'], path)
    },
    dewpoint () {
      if (this.$store.getters['station/lastData'] === null) {
        return 0
      }
      const path = [this.meteo.getId(), this.meteo.getDewPoint()]

      return object.get(this.$store.getters['station/lastData'], path)
    }
  }
}
</script>
